module.exports = "./assets/assets/相关政策依据.be7c95f9.docx";